import Meta from './Meta';

export default Meta;



// WEBPACK FOOTER //
// ./src/components/Page/Meta/index.tsx